import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectHero from '../../components/hero3/projecthero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Video from '../../images/Video.png';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ClientNumber from '../../components/business-consulting-components/clientnumber';
import srj1 from '../../images/elise1.png'
import srj2 from '../../images/srj2.svg'
import srj3 from '../../images/nicolas3.png'
import srj7 from '../../images/nicolas7.png'
import srj8 from '../../images/srj8.png'
import srj9 from '../../images/srj9.png'
import srj10 from '../../images/nicolas10.png'
import CaseStudiesSlider from '../../components/business-consulting-components/CaseStudiesSlider';



const Nicolas = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <ProjectHero top_title={<>Dual-Sided Growth for a <br/> SaaS Influencer Marketing <br/> Platform (US)</>}/>

                    <section className="video_section">
                        <div className="container text-center project_page_desp">
                            <h2>Company Overview</h2>

                            <ul className='project_page_ul'>
                                <li>
                                    <span className='number_css'>15+</span>
                                    <span className='hero_bottom_text'>Team Size</span>
                                </li>
                                <li>
                                    <span className='number_css'>US</span>
                                    <span className='hero_bottom_text'>Country</span>
                                </li>
                                <li>
                                    <span className='number_css'>Saas</span>
                                    <span className='hero_bottom_text'>Industry</span>
                                </li>
                                <li>
                                    <span className='number_css'>Influencer Marketing Platform</span>
                                    <span className='hero_bottom_text'>Category</span>
                                </li>
                            </ul> 
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>About Business</h2>
                                    <p className='heading_description text-dark mb-0'>Nicolas is the founder of a US-based SaaS <br/> platform for influencer marketing and <br/> management. The product helps brands discover, <br/> onboard, and manage influencers while giving <br/> creators a clean experience for offers, briefs, and <br/> payouts.</p>
                                </div>

                                <div className="col-lg-6" style={{textAlign:'right'}}>
                                    <img src={srj1} alt="srj1" style={{maxWidth:'60%'}}/>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj2} alt="aiseo" className='img-fluid' style={{maxWidth:'60%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Client Challenges</h2>
                                    <p className='heading_description text-dark mb-0'>After launching in 2023 and onboarding early brands, growth plateaued. The team struggled to scale both sides of the marketplace—brand acquisition and influencer acquisition—despite prior engagements with multiple agencies.</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Two-sided marketplace friction: activating both brand demand and influencer supply at the same time.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>CAC rising while activation and onboarding rates lagged; attribution unclear across channels.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Content saturation around “influencer marketing” terms; difficulty standing out on SERPs and social.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Disjointed lifecycle: email, ads, SEO, and product onboarding were not orchestrated.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Past agencies produced activity but not compounding growth or clear channel priorities.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Overview</h2>
                                    <h3 className='mt-4'>SEO Brief</h3>
                                    <p className='heading_description text-dark mb-0'>During onboarding, Nicolas shared that several SEO/marketing partners had failed to deliver. A founder friend referred Digi Pexel based on prior results, and Nicolas asked for a long-term, accountable team to own marketing end-to-end so he could focus on business development. He specifically wanted a partner that could acquire both brands and influencers in a predictable, scalable way.</p>
                                   
                                     <h3 className='mt-4'>Client Ask</h3>
                                      <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Identify the primary, scalable channels for a dual-audience platform (brands and influencers).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Build a sustainable SEO + content + demand-gen strategy for acquiring both sides.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Run omnichannel execution across Social, SEO, Email, and Google Ads with clear attribution.</li>
                                    </ul>


                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section max_900 section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <img src={srj3} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj7} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row challenges_css">
                                <div className="col-lg-6">
                                    <img src={srj8} alt="aiseo" className='img-fluid' style={{maxWidth:'70%',marginTop:'20%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Challenges We Faced</h2>
                                    <p className='heading_description text-dark mb-0'>While working on this project, there are many challenges that we have faced, like this being a very competitive niche and lots of big brands are in this category. The following are some of the issues that have been faced.</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Ambiguous success definitions across funnel stages (trial → activated brand; invited → verified creator).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Keyword cannibalization between feature pages, solutions pages, and long-form guides.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Trust/quality signals for creators (fake followers, inactive profiles) are impacting brand confidence.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Lifecycle fragmentation: email cadences not aligned with in-app milestones.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Limited author/reviewer signals on thought-leadership content.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space solution pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>Solution Provided</h2>
                                </div>

                                <div className="col-lg-6">
                                    <ul class="srj_list solution_list mt-4">
                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Diagnosis & Audit</div>
                                                <p><b>90-point Technical Audit:</b> crawlability, JS rendering, canonicalization, sitemap/robots, template duplication; plus IA review to separate feature, solution, and “how-to” content. We also mapped app vs marketing subdomains to ensure clean indexation.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Content Strategy (Topical & Location Authority)</div>
                                                <p>Built a pillar-cluster model around “Influencer CRM,” “UGC Campaigns,” “Whitelisting Ads,” “Creator Payments,” and “FTC-compliant briefs,” with clusters for “Find influencers by platform/vertical” and “Campaign reporting”. Each cluster is aligned to brand or creator intent with comparison pages (e.g., “Influencer platform vs agency”) and case-led stories.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>AI-SEO (AEO/GEO)</div>
                                                <p>Structured Q&A modules, glossaries, and FAQ schema to perform in AI overviews and answer engines for queries like “how to create influencer briefs,” “whitelisting ads meaning,” and “UGC vs influencer marketing”.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>On-Page Strategy</div>
                                                <p>Intent-segmented copy (brand vs creator) with modular CTAs: “Start Free Trial,” “Book a Demo,” “Apply as Creator,” “Verify Profile.” Introduced solution-pattern blocks, pricing expanders, and social proof bands per audience.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Schema Enhancements</div>
                                                <p>Implemented Organization, Product (plans/features), FAQ, Breadcrumb, and Review schema; reinforced the internal link graph to route discovery-stage traffic into intent pages (features/solutions) and frictionless trial flows.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>CRO & Lead Quality Uplift</div>
                                                <p>Redesigned signup with progressive profiling (brand or creator path), budget/vertical tags, and “import brief” accelerators. Added creator verification gates and trust badges for brands. Gated high-intent assets (brief templates, outreach scripts, ROI calculators) with minimal friction to improve MQL→SQL and trial→activation.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Digital PR & Partnerships</div>
                                                <p>Bylines on ad/creator economy publications, reclaiming unlinked mentions, and partnership pages for agencies/marketplaces. Activated a “Creator Council” for expert quotes and co-marketing.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Analytics, Governance & RevOps</div>
                                                <p>GA4 + GSC + CRM stitched to product analytics for multi-touch attribution; dashboards by audience (brand vs creator) and milestone (trial, brief sent, creator hired). Quarterly roadmap tied to content expansion, template launches, and market-specific pages.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Paid Ads (Google, LinkedIn, Meta, TikTok)</div>
                                                <p>Capture high-intent queries (“influencer marketing platform,” “influencer CRM,” “UGC platform”) with SKAG/SMAG structure; split brand vs non-brand; PMax for incremental surfaces and remarketing.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Social Media Marketing</div>
                                                <ul>
                                                    <li>LinkedIn and X thought-leadership: campaign strategy threads, whitelisting guides, and FTC updates.</li>
                                                    <li>Founder POV posts; short demo clips; “Template Tuesday” posts linking to gated assets.</li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Email Marketing</div>
                                                <p>We have done the complete email marketing by setting up the Lifecycle, Drip & Sales Enablement campaigns </p>
                                            </div>
                                        </li>


                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <ToolSection title1={<>Partner with us and get your custom AI SEO <br/> strategy for your business.</>} title2='' />
                    
                    <section className="intro_about_section section_space project_outcome pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Outcome</h2>
                                </div>

                                <div className="col-lg-10 offset-lg-2">
                                    <ul class="srj_list solution_list mt-4">

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Clear Channel Focus</div>
                                                <p>Clear channel focus: SEO + product-led content for brands; social + partner funnels for creators.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Better Lead Quality</div>
                                                <p>Improved trial quality and faster time-to-first-brief via segmented onboarding and templates.</p>
                                            </div>
                                        </li>

                                         <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Trust Building</div>
                                                <p>Stronger trust signals (creator verification; public case studies) are boosting brand conversions.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Good Lead Flow</div>
                                                <p>Measurable lift in qualified pipeline and better attribution across paid/owned media.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </section>
                    <ClientNumber/>

                    <section className="intro_about_section section_space project_outcome">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj10} alt="srj10" className='img-fluid' />
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container max_900">
                            <div className="row">
                                <div className="col-lg-12 text-center tool_section_new">
                                    <h2>Partner with us and get your custom AI SEO <br/> strategy for your business</h2>
                                    <button className="read_more btn btn-secondary">Contact Now</button>
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <CaseStudiesSlider/>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default Nicolas;
